import { ComponentType, PropsWithChildren, useMemo } from 'react';

import createSettingsHOC, {
  Props,
  SharedProps,
} from 'src/components/settings/create-settings-hoc';
import { useParams } from 'src/router/hooks';
import urls from 'src/sections/workspace/urls';

import WorkspaceSettingsBreadcrumbs from '../components/breadcrumbs';

const Breadcrumbs = (): JSX.Element => {
  const { workspaceSlug } = useParams<{ workspaceSlug: string }>();
  const settingsHref = urls.ui.settings(workspaceSlug || '');
  return <WorkspaceSettingsBreadcrumbs settingsHref={settingsHref} />;
};

/**
 * in order to use the hooks we need to be inside a function that returns FC
 * so wrapping this in a dummy function component
 */
const withWorkspaceSettings = <P,>(
  Component: ComponentType<PropsWithChildren<P & Props & SharedProps>>,
  componentProps?: Props
) => {
  return (props: P & Props) => {
    // memoizing to avoid unnecessary remounting which causes bugs
    const FinalComponent = useMemo(
      () =>
        createSettingsHOC({
          breadcrumbs: Breadcrumbs,
        })(Component, componentProps),
      []
    );

    return <FinalComponent {...props} />;
  };
};

// eslint-disable-next-line import/no-default-export
export default withWorkspaceSettings;
